export const STATUS_ATTRIBUTE = 'data-status';
export const PASSENGER_ATTRIBUTE = 'data-passenger-id';

export const attributes = [STATUS_ATTRIBUTE, PASSENGER_ATTRIBUTE];

export const status = {
  SELECTED: 'selected',
  ASSIGNED: 'assigned',
  UNAVAILABLE: 'unavailable',
  NON_EDITABLE: 'non-editable',
  BLOCKED: 'blocked'
};

export const CARRIAGE_BLOCKED_REASONS = ['OD_PRIORITY'];

export const SEAT_PRIORITY_CODE = 'PRIORITY';
